<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <div class="one-bd clearfix">
                <a :class="{active:type === 1}" href="javascript:void(0);" @click="getAccountList(1);">微信账号</a>
                <a :class="{active:type === 2}" href="javascript:void(0);" @click="getAccountList(2);">微博账号</a>
                <a :class="{active:type === 3}" href="javascript:void(0);" @click="getAccountList(3);">头条账号</a>
                <a :class="{active:type === 4}" href="javascript:void(0);" @click="getAccountList(4);">快手账号</a>
                <a :class="{active:type === 5}" href="javascript:void(0);" @click="getAccountList(5);">B站账号</a>
                <a :class="{active:type === 6}" href="javascript:void(0);" @click="getAccountList(6);">抖音账号</a>
                <a :class="{active:type === 7}" href="javascript:void(0);" @click="getAccountList(7);" v-if="types==1">微博账号（新）</a>
            </div>
        </div>
        <div class="account-bd">&nbsp;</div>
        <div class="bgfff">
            <div class="bd clearfix">
                <a class="btn btn-blue fl" :href="url" target="_blank"><i class="icons add-blue-icon"></i>添加账号</a>
                <router-link class="ms-tag fr ml25" to='/accountList/accountListTag'>
                    <i class="icons icon-tag"></i>管理标签
                </router-link>
                <div class="dropdown-toggle fr">
                    <div class="dropdown w168">
                        <span>{{labelName}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w447">
                        <div class="search-warp">
                            <input type="text" name="search" placeholder="请输入标签名" class="input-text" v-model="keyWord" @keyup="labelSearch();">
                            <span class="search-btn" href="javascript:void(0);" @click="labelSearch">
                                <i class="icons search-icon1"></i>
                            </span>
                        </div>
                        <ul class="dropdown-menu" role="menu">
                            <li class="cp" v-for="(item,index) in lableList" :key="index" @click="labelClickSearch(item.id,item.name);">{{item.name}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <ul class="account-list mt30 clearfix">
                <li v-for="(item,index) in accountList" :key="index">
                    <div class="clearfix">
                        <div class="account-img fl"><img :src="item.headImg" /></div>
                        <div class="account-r">
                            <i class="icons cp icon-del" @click="delAccount(index);"></i>
                            <p>{{item.nickname}}</p>
                            <span class="fs12">{{item.alias}}</span>
                            <p>
                                <span class="warn mt10" :class="state[item.authorized]">&nbsp;{{item.authorizedZh}}</span>
                                <span class="warn mt10" :class="state[item.verifyTypeInfo]">&nbsp;{{item.verifyTypeInfoZh}}</span>
                                <span v-if="item.status" style="margin-left:10px">状态:{{item.status}}</span>
                                <a class="color-blue cxsq-a" :href="url" target="_blank" v-if="item.authorized != 1 || item.needReAuth == 1">重新授权</a>
                            </p>
                        </div>
                    </div>
                    <div class="account-b mt10">
                        <span v-if="item.accountLabel.length <= 0">未打标签,去 <router-link class="color-blue cp" to="/accountList/accountListTag">打标签</router-link></span>
                        <router-link class="label"  to="/accountList/accountListTag" v-for="(i,j) in item.accountLabel" :key="j">{{i}}</router-link>
                    </div>
                </li>
            </ul>
            <!-- 暂无数据 -->
            <div class="no-data" v-if="accountList <= 0 && !$parent.showLoad"><img src="/static/images/no_data.png" class="img" /><span class="text">没有数据哦...</span></div>
            <!-- 分页 -->
            <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
        </div>
        <!-- 是否删除提示 -->
        <Dialog ref="delModal" :callback="enterDel" type="confirm" title="提示">
            <div slot="mdBox">
                <p class="ac">是否删除该账号？</p>
            </div>
        </Dialog>
  	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import page from '../../components/page.vue';
export default {
    components:{Dialog,page},
    data() {
        return {
            state:['yc','zc','sx'],//状态
            userInterface:['member/wxlist','member/wblist','member/ttlist','member/ks-list','member/bili-list','member/dy-list','newoauth/wblist'],
            url:'',//授权地址
            type:1,//账号列表类型
            czIndex:'',//当前操作的索引
            initialAccountList:[],//账户初始列表
            accountList:[],//账户列表
            initialLableList:[],//初始标签列表
            lableList:[],//实际标签显示
            labelName:'全部',//标签名称
            lableId:'',//标签ID
            keyWord:'',//标签搜索关键词
            totalCount:'',
            page:1,
            limit:20,
            types:''
        }
    },
    mounted() {
        let that = this;
        // console.log(this.$route.query);
        if(this.$route.query.type){
            this.types = 1
        }
        this.$nextTick(()=> {
            that.getAccountList(1);
        })
    },
    created() {

    },
    methods: {
        // 获取账户列表
        getAccountList (type,pageType) {
            let that = this;
            that.type = type;
            if(pageType === 0){//重置第一页
                that.page = 1;
            }
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post(that.userInterface[type-1],{id:that.lableId,page:that.page,pagesize:that.limit},r =>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.accountList = r.data.list;
                    that.totalCount = r.data.total;
                    that.url = r.data.url;
                })
            })
            that.getLabel();
        },
        // 获取标签
        getLabel () {
            let that = this;
            that.$api.post('label/list',{type:that.type},r =>{
                that.$parent.returnCode(r,function(){
                    that.lableList = r.data;
                    that.initialLableList = r.data;
                    that.lableId = r.data[0].id;
                })
            })
        },
        // 标签搜索
        labelSearch () {
            let that = this;
            let list = [];
            let initialLableList = that.initialLableList;
            let keyWord = that.keyWord;
            for(let i of initialLableList){
                if(i.name.indexOf(keyWord) != -1){
                    list.push(i);
                }
            }
            that.lableList = list;
        },
        // 标签点击筛选
        labelClickSearch (id,name) {
            let that = this;
            that.lableId = id;
            that.labelName = name;
            let type = that.type;
            that.getAccountList(type,0);
        },
        // 账户列表翻页
        getTableData () {
            this.getAccountList(this.type,1);
        },
        // 删除账号
        delAccount (index) {
            this.czIndex = index;
            this.$refs.delModal.showMaskFun();
        },
        // 确认删除
        enterDel () {
            let that = this;
            let id = that.accountList[that.czIndex].id;
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('member/delaccount',{type:that.type,id:id},r =>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.getAccountList(that.type,0);
                    that.$utils.alertText('删除成功');
                    that.$refs.delModal.closeMask();
                })
            })
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/page/accountList/accountList.vue